<template>
  <DefaultLayout />
</template>

<script setup lang="ts">
import DefaultLayout from '@/layout/DefaultLayout.vue'
</script>
